export default "__VITE_ASSET__x5jMmKmM__"